import { useContext, useRef } from "react";
import { useDispatch } from "react-redux";
import TickGreen from '../../../Assets/Modals/TickGreen.svg';
import { closeModal, fetchOrders } from '../../../Features/orderManagementSlice';
import { OrdersManagementContext } from "../../../Context/OrdersManagementContext";
import { getNextDate, getRandomTime } from "../../../lib/utils/utils";
import { useSelector } from "react-redux";
import { generatePickup, getPostProfile, updateOrder } from "../../../lib/utils/apiCalls";
import { toast } from "react-toastify";
import { showToast } from "../../../Components/Toaster/Toaster";
import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick";

function CallPickupModal() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const { selectedOrders, setSelectedOrders } = useContext(OrdersManagementContext);
    const user = useSelector((state) => state.user.user);

    const handleCancelButttonClick = () => {
        dispatch(closeModal());
    }

    async function handleConfirm() {
        const now = new Date();
        const currentDate = now.toISOString().split('T')[0];
        const hour = now.getHours();

        const pickupDate = hour < 14 ? currentDate : getNextDate(currentDate);
        const pickupTime = getRandomTime();

        try {
            let storeName = '';
            const storeId = user?.SellerUserId;
            const profile = await getPostProfile(storeId);
            storeName = profile.name;

            const callData = {
                pickup_location: storeName,
                package_count: selectedOrders?.length,
                pickup_date: pickupDate,
                pickup_time: pickupTime
            };

            await generatePickup(callData);
        }
        catch(err) {
            showToast('Error creating pickup', 'error');
        }

        const updatePromises = selectedOrders.map(orderId => updateOrder({
            id: orderId,
            orderStatus: 'READY_FOR_PICKUP',
        }));

        const updateAllPromise = Promise.all(updatePromises);
        
        toast.promise(
            updateAllPromise,
            {
                pending: {
                    render() {
                        return 'Updating selected orders...';
                    },
                    className: 'toast-pending',
                },
                success: {
                    render() {
                        return 'Order status updated.';
                    },
                },
            }
        );

        try {
            await updateAllPromise;
            showToast(
                `Pickup created for ${pickupDate || pickupDate} at ${pickupTime || pickupTime}!`,
                'success'
            );
            dispatch(fetchOrders());
            dispatch(closeModal());
            setSelectedOrders([]);
        }
        catch(err) {
            showToast('Failed to update order status. Please try again.', 'error');
        }
    }

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Call Pickup</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>By clicking confirm, we initiate the request to pick from our delivery partner</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelButttonClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleConfirm} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-primaryColor hover:bg-primaryAccent shadow-[0px_1px_2px_0px_#0000000D]'>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CallPickupModal;
